import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {LocationStatusFacet, LocationStatusFacetEntity} from "../../../model/service/location-status-facet";

export interface LocationStatusFacetSelectorProps {
  siteId?: string
}

const getSiteIdParam = createParamSelector<LocationStatusFacetSelectorProps | undefined, string | undefined>(params => params?.siteId);

export const locationStatusFacetsSelector = () => createSelector(
  [getUseQueryResultData<LocationStatusFacet[]>, getSiteIdParam],
  (data, siteId) => {
    return selectLocationStatusFacetsAndTransform(
      data ?? [], {siteId: siteId}
    );
  }
);

export const locationStatusFacetSelector = () => createSelector(
  [getUseQueryResultData<LocationStatusFacet>],
  (data) => {
    return data ? transformLocationStatusFacet(data) : undefined;
  }
);

export const selectLocationStatusFacets = (values?: LocationStatusFacet[], selector?: LocationStatusFacetSelectorProps): LocationStatusFacet[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.siteId) {
      if (v.siteId !== selector.siteId) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const transformLocationStatusFacet = (value: LocationStatusFacet): LocationStatusFacetEntity => {
  return LocationStatusFacetEntity.from(value)
}

export const selectLocationStatusFacetsAndTransform = (values?: LocationStatusFacet[], selector?: LocationStatusFacetSelectorProps): LocationStatusFacetEntity[] => {
  const selected = selectLocationStatusFacets(values, selector);
  return selected.map(transformLocationStatusFacet);
};
